module.exports = __webpack_public_path__ + "static/media/import_icon.525fc207.svg";